<div id="container">
    <app-spalla></app-spalla>
    <main>
        <app-header></app-header>        
    </main>
</div>